"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.userProfileReducer = exports.setProfileFacetecDBRef = exports.clearFaceTecActions = exports.setFaceTecActions = exports.clearFirebaseUserProfile = exports.setUserProfileError = exports.setFirebaseUserProfile = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var _devMode = process.env.NODE_ENV === "development";
// Helper to get persisted facetec state from sessionStorage
var getPersistedFacetecState = function () {
    var _a, _b;
    try {
        var stored = sessionStorage.getItem("facetec_auth_state");
        if (stored) {
            var parsed = JSON.parse(stored);
            return {
                authenticated: (_a = parsed.authenticated) !== null && _a !== void 0 ? _a : false,
                actionAuthenticated: (_b = parsed.actionAuthenticated) !== null && _b !== void 0 ? _b : (_devMode !== null && _devMode !== void 0 ? _devMode : false),
            };
        }
    }
    catch (_c) {
        // Ignore parsing errors
    }
    return {
        authenticated: false,
        actionAuthenticated: _devMode !== null && _devMode !== void 0 ? _devMode : false,
    };
};
var initialState = {
    profile: null,
    loaded: false,
    facetec: getPersistedFacetecState(),
};
var userProfileSlice = (0, toolkit_1.createSlice)({
    name: "userProfileSlice",
    initialState: initialState,
    reducers: {
        setFirebaseUserProfile: function (state, action) {
            state.profile = action.payload;
            state.loaded = true;
            state.error = undefined;
        },
        setFaceTecActions: function (state, action) {
            state.facetec = {
                authenticated: action.payload.authenticated,
                actionAuthenticated: action.payload.actionAuthenticated,
            };
            // Persist to sessionStorage so it survives page refresh
            try {
                sessionStorage.setItem("facetec_auth_state", JSON.stringify(action.payload));
            }
            catch (_a) {
                // Ignore storage errors
            }
        },
        setUserProfileError: function (state, action) {
            state.error = action.payload;
            state.loaded = true;
        },
        clearFirebaseUserProfile: function (state) {
            state.profile = null;
            state.loaded = false;
            state.error = undefined;
        },
        clearFaceTecActions: function (state) {
            state.facetec = {
                authenticated: false,
                actionAuthenticated: false,
            };
            // Clear from sessionStorage on logout
            try {
                sessionStorage.removeItem("facetec_auth_state");
            }
            catch (_a) {
                // Ignore storage errors
            }
        },
        // Update facetecDBRef in the user profile without replacing entire profile
        setProfileFacetecDBRef: function (state, action) {
            if (state.profile) {
                state.profile.facetecDBRef = action.payload;
            }
        },
    },
});
exports.setFirebaseUserProfile = (_a = userProfileSlice.actions, _a.setFirebaseUserProfile), exports.setUserProfileError = _a.setUserProfileError, exports.clearFirebaseUserProfile = _a.clearFirebaseUserProfile, exports.setFaceTecActions = _a.setFaceTecActions, exports.clearFaceTecActions = _a.clearFaceTecActions, exports.setProfileFacetecDBRef = _a.setProfileFacetecDBRef;
exports.userProfileReducer = userProfileSlice.reducer;
